import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ConfirmationPrompt = ({ show, message = "OTM_PROCEED_?", onConfirm, onCancel, identifier = "" }) => {
    const [translate] = useTranslation();
    
    return(
        <BootstrapModal show={show} backdrop="static">
            <BootstrapModal.Header className="h5 text-secondary">{translate("OTM_CONFIRM")}</BootstrapModal.Header>
            <BootstrapModal.Body>
                <label>{translate(message)}</label>
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button onClick={() => onConfirm(identifier)} variant="primary" className="btn-sm">{translate("OTM_CONFIRM")}</Button>
                <Button onClick={onCancel} variant="secondary" className="btn-sm">{translate("OTM_CANCEL")}</Button>
            </BootstrapModal.Footer>
        </BootstrapModal>
    );
};

export default ConfirmationPrompt;